import {
  Box,
  Card,
  CardContent,
  Typography,
  CardActions,
  Link,
} from "@mui/material";
import {
  LastBillsDataCard,
  LastBillsTableRow,
} from "../../../core/models/lastBills/lastBills.model";
import "./LastBillsCard.scss";
import SuppliesBillsStateContent from "../../SuppliesBillsStateContent/SuppliesBillsStateContent";
import { useTranslation } from "react-i18next";
import EnvirormentContent from "../../EnvirormentContent/EnvirormentContent";
import LoadingComponentComponent from "../../UI/LoadingComponentComponent/LoadingComponentComponent";
import { useEffect, useState } from "react";

export interface LastBillsCardProps {
  lastBillsTableRows: LastBillsTableRow[];
  handleClickDonwloadBill: (id: string) => Promise<void>;
  isDownloadLoading: boolean;
}

const LastBillsCard = ({
  lastBillsTableRows,
  handleClickDonwloadBill,
  isDownloadLoading,
}: LastBillsCardProps) => {
  const { t } = useTranslation();
  const [rowId, setRowId] = useState<string[]>([]);
  useEffect(() => {
    if (!isDownloadLoading) {
      setRowId([]);
    }
  }, [isDownloadLoading]);

  const lastBillsDataCard: LastBillsDataCard[] = [
    {
      id: "service",
      title: "Servicio",
      cellContent: (row) => (
        <EnvirormentContent service={row.service} variant={"body1"} />
      ),
    },
    {
      id: "billDate",
      title: "Fecha de emisión",
      contentVariant: "subtitle1",
      fontWeight: "700",
    },
    {
      id: "period",
      title: "Periodo",
    },
    {
      id: "amount",
      title: "Importe",
      fontWeight: "700",
    },
    {
      id: "state",
      title: "",
      cellContent: (row) => <SuppliesBillsStateContent state={row.state} />,
    },
  ];

  return (
    <Box
      component="article"
      className="last-bills-cards"
      sx={{ marginBottom: 5 }}
    >
      {lastBillsTableRows.map((row) => (
        <Card
          key={`${row.id}}`}
          sx={{ marginBottom: "16px", position: "relative" }}
        >
          <CardContent sx={{ paddingY: "12px", paddingX: 2 }}>
            {lastBillsDataCard.map(
              ({ id, title, contentVariant, fontWeight, cellContent }) => {
                const textContent = row[id];
                return (
                  <Box key={id} sx={{ marginBottom: 2 }}>
                    {!!title.length && (
                      <Typography
                        variant="subtitle2"
                        component="h4"
                        sx={{
                          color: "grey.700",
                        }}
                      >
                        {t(`Tablas.${title}`)}
                      </Typography>
                    )}
                    {cellContent ? (
                      cellContent(row)
                    ) : (
                      <Typography
                        gutterBottom
                        variant={contentVariant || "body1"}
                        component="p"
                        fontWeight={fontWeight || 400}
                      >
                        {textContent}
                      </Typography>
                    )}
                  </Box>
                );
              }
            )}
          </CardContent>
          <CardActions sx={{ paddingY: "12px", paddingX: 2 }}>
            <Link
              component="button"
              underline="none"
              onClick={() => {
                handleClickDonwloadBill(row.id);
                setRowId((prevRowId) => [...prevRowId, row.id]);
              }}
              variant="button"
            >
              <Typography
                component="span"
                aria-hidden="true"
                className="t-icon-download"
                sx={{ paddingRight: "10px" }}
              />{" "}
              {t("Facturas Página.Descargar factura")}
            </Link>
          </CardActions>
          {isDownloadLoading && rowId.includes(row.id) && (
            <LoadingComponentComponent
              isLoading={isDownloadLoading}
              opacity={0.5}
            />
          )}
        </Card>
      ))}
    </Box>
  );
};

export default LastBillsCard;
